import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'publishing',
  label: 'Publishing',
  heroTitle: 'Monetize Your',
  heroDim: 'Editorial Data',
  heroSubtitle:
    'Publishers make thousands of high-signal decisions every year — what to acquire, how to edit, what to cut, and why. Efficient helps you license this editorial intelligence to AI companies, creating a new revenue stream with no disruption to your operations.',
  heroImage: '/publishing-hero.webp',
  heroImageAlt: 'Independent bookstore',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: 'We evaluate your editorial records — acquisition decisions, revision histories, editorial notes — and identify what has value in the AI training market.',
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Qualification',
      desc: 'We match your data to AI buyers building writing, editing, and content quality tools, and provide a transparent quote.',
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'Preparation',
      desc: 'We structure and anonymize your editorial data for delivery — ensuring all author and contributor information is handled compliantly.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'We pay out your revenue share upon delivery. Your editorial process becomes a recurring income asset.',
    },
  ],
  valueHeading: 'What publishing data can be monetized',
  valueProps: [
    {
      title: 'Acquisition Decisions & Rationale',
      desc: 'The reasoning behind what gets greenlit — and what gets passed on — captures editorial intuition and market judgment built across thousands of submissions.',
    },
    {
      title: 'Editorial Notes & Revision Histories',
      desc: 'Tracked changes and editorial comments document the craft of transforming raw writing into polished, publishable work — expertise that takes years to develop.',
    },
    {
      title: 'Structural & Style Decisions',
      desc: 'Choices about structure, pacing, and voice encode deep expertise about what makes writing resonate — the kind of instinct your editors have sharpened over careers.',
    },
  ],
  aiAccelHeading: 'Accelerate your editorial process with AI.',
  aiAccelPoints: [
    {
      title: 'Manuscript Analysis',
      desc: 'AI tools can assess submissions against your house style, flag structural issues, and surface comparable titles — speeding up acquisition decisions.',
    },
    {
      title: 'Editorial Workflow Automation',
      desc: 'Automate copyediting passes, consistency checks, and metadata tagging so your team spends time on judgment, not repetitive review.',
    },
    {
      title: 'Rights & Licensing Intelligence',
      desc: 'Track rights windows, identify licensing opportunities, and get AI-assisted analysis of your catalog\'s commercial potential.',
    },
  ],
  ctaHeading: 'Your editorial judgment has market value',
  ctaBody:
    'Join our network of publishing partners and turn your editorial process into a new revenue stream — securely and compliantly.',
};

export default function Publishing() {
  return <IndustryTemplate config={config} />;
}
